Vue.component('ack-get-quote', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-get-quote',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-get-quote mounted')
      if (window.hbspt) {
        this.createForm()
        this.setPageIsLoading(false)
      } else {
        this.loadScript().then(()=>{
          this.createForm()
          this.setPageIsLoading(false)
        })
      }
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }
      
    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']), 
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'get-quote-page',
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      loadScript() {
        return new Promise((resolve) => {
          const script = document.createElement('script')
          script.src = '//js.hsforms.net/forms/v2.js'
          script.onload = resolve
          document.body.appendChild(script)
        })
    },
    createForm() {
        if (window.hbspt) {
          window.hbspt.forms.create({
            target: '#hs-form',
            region: 'na1',
            portalId: '2471334',
            formId: 'deb42739-4d04-4bd5-8e29-0eedd976683e',
          })
        }
      },
      
  
    },
    beforeDestroy() {
      
    },
    watch: {
      
      data1: {
        handler() {
          
          
          
        },
        deep: false
      }
    }
  })